/**
 * How an identifier is shown to a person.
 *
 * The API keeps typed prefixes (`ord_`, `acc_`, `ak_live_`) because support, logs and secret
 * scanners rely on them. A screen does not: a full ULID is 30 characters of noise that nobody
 * reads and everybody copies. So a list shows a SHORT CODE and the full value is one click
 * away (`docs/product/dashboard-rework.md`, "Identifiers in the UI").
 */
/** `#3WQ7XK2M` — the last eight characters, which is what distinguishes two rows in practice. */
export function shortCode(id, length = 8) {
    const tail = id.slice(-length);
    return `#${tail.toUpperCase()}`;
}
/** `TQn9Y2…cbLSE` — enough of an address to recognise, short enough to sit in a table cell. */
export function shortAddress(address, head = 6, tail = 5) {
    if (address.length <= head + tail + 1)
        return address;
    return `${address.slice(0, head)}…${address.slice(-tail)}`;
}
/**
 * The title of an account: its display name when it has one, the shortened owner address when
 * it does not. NEVER the account id — that belongs under "Account ID (for support)" and
 * nowhere else.
 */
export function accountTitle(displayName, ownerAddress) {
    const named = displayName?.trim();
    if (named)
        return named;
    if (ownerAddress)
        return shortAddress(ownerAddress);
    return "Your account";
}
//# sourceMappingURL=identifiers.js.map